import { createFileRoute } from "@tanstack/react-router";

import { StartIndexPage } from "@pages/start/StartIndexPage";

import { useAccountActivationAuthStore } from "src/services/accountActivation/authStore";

export const Route = createFileRoute("/start/")({
  component: StartIndexPage,
  beforeLoad(ctx) {
    // clear this value so when page is mounted we dont try to do anything w/
    // old oauth2 token
    useAccountActivationAuthStore.setState({ oauth2Token: undefined });
  },
});
